import { render, staticRenderFns } from "./pgsearchresults.vue?vue&type=template&id=7dda68a2&"
import script from "./pgsearchresults.vue?vue&type=script&lang=js&"
export * from "./pgsearchresults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports